import React, { Component } from "react";
import HeaderMenu from "../../components/ui-elements/header";
import KooeeBanner from "../../components/ui-elements/banner";
import BannerLabel from "../../components/ui-elements/bannerLabel";
import { withStyles, Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { styles } from "./styles";
import KooeeContainer from "../../components/ui-elements/kooeeContainer";
import StateInput from "../../components/energyCostCalculator/stateInput";
import CostCalculator from "../../components/energyCostCalculator/costCalculate";
import energyCostCalcAction from "../../redux/energyCostCalc/actions";
import benefitsCalcAction from "../../redux/benefits/actions";

const { findState, getEstimatedBill } = energyCostCalcAction;
const { getBenefitsAndPayments } = benefitsCalcAction;

const marks = [
  {
    value: 1
  },
  {
    value: 2
  },
  {
    value: 3
  },
  {
    value: 4
  },
  {
    value: 5
  },
  {
    value: 6
  },
  {
    value: 7
  }
];

const slider = {
  marks: marks,
  min: 1,
  max: 7,
  default: 4,
  step: 1
};

export class EnergyCostCalculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postalCode: "",
      calculator: false,
      stateCode: "",
      estimatedAnnualBill: "",
      loading: false,
      selectedData: {},
      setToView: true
    };
    this.myDivToFocus = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      stateCode: props.stateCode,
      estimatedAnnualBill: props.estimatedBill.quarterBillAmount
    };
  }

  componentDidUpdate(prevProps) {
    const { stateFetching, benefitsFetching } = this.props;
    if (stateFetching !== prevProps.stateFetching && prevProps.stateFetching) {
      this.setState({
        loading: false
      });
    }
    if (benefitsFetching !== prevProps.benefitsFetching && prevProps.benefitsFetching) {
      if (this.state.loading) {
        this.setState({
          loading: false
        });
        this.goToBenefits();
      }
    }
    if (this.myDivToFocus.current && this.state.setToView) {
      window.scrollTo({
        bottom: this.myDivToFocus.current.offsetTop,
        behavior: "smooth"
      });
      this.myDivToFocus.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }

  setPostal = value => {
    const { findState } = this.props.actions;
    // sessionStorage.setItem("postal", value);
    this.setState({
      postalCode: value,
      calculator: true,
      loading: true,
      setToView: true
    });

    findState(value);
  };

  goToBenefits = () => {
    this.props.history.push({
      pathname: "/benefits-wall",
      state: {
        detail: this.state.selectedData
      }
    });
  };

  averageBillCal = (headCount, items, rating) => {
    const { getEstimatedBill } = this.props.actions;
    const dataObj = {
      stateCode: this.state.stateCode,
      headCount: headCount[0],
      pool: items.includes("pool"),
      battery: items.includes("battery"),
      solar: items.includes("solar"),
      rating: rating
    };
    this.setState({
      selectedData: dataObj,
      setToView: false
    });
    getEstimatedBill(dataObj);
  };

  getBenefitsAndPayments = billAmount => {
    const { getBenefitsAndPayments } = this.props.actions;
    const dataObj = {
      stateCode: this.state.stateCode,
      annualBill: billAmount ? billAmount : this.state.estimatedAnnualBill,
      smartHome: false,
      battery: false,
      solar: false,
      deposit: 0,
      householdSize: this.state.selectedData ? this.state.selectedData.headCount : 1,
      hasSolar: this.state.selectedData ? this.state.selectedData.solar : false,
      hasBattery: this.state.selectedData ? this.state.selectedData.battery : false,
      hasPool: this.state.selectedData ? this.state.selectedData.pool : false,
      wasteFactor: this.state.selectedData ? this.state.selectedData.rating : 4
    };
    this.setState({
      loading: true
    });
    sessionStorage.setItem("state", this.state.stateCode);
    sessionStorage.setItem("annualBill", billAmount ? billAmount : this.state.estimatedAnnualBill);
    getBenefitsAndPayments(dataObj);
  };

  render() {
    const { classes, benefitsFetching } = this.props;
    const { loading, calculator, postalCode, estimatedAnnualBill } = this.state;
    const search = this.props.history.location.search;
    const noFnPayBgt = new URLSearchParams(search).get('no_fn_pay_bgt');
    const showFn = new URLSearchParams(search).get('show_fn');
    return (
      <Grid  container direction="column" justifyContent="space-between" alignItems="stretch">
        <Grid item xs >
          <HeaderMenu noFnPayBgt={noFnPayBgt} showFn={showFn} />
          {/* <hr className={classes.seperater}></hr> */}
          <Grid className={classes.seperater}></Grid>
          {/* <KooeeBanner /> */}
          <BannerLabel headerTitle="About You" subTitle="We need some basic information so we can calculate the right size NRG Solar system for you" />
        </Grid>
        <Grid  className={classes.root} container direction="column" justifyContent="space-between" alignItems="stretch">
          <KooeeContainer
            content={
              calculator && !loading ? (
                <CostCalculator
                  history={this.props.history}
                  postalCode={postalCode}
                  sliderProps={slider}
                  averageBillCal={this.averageBillCal}
                  estimatedAnnualBill={estimatedAnnualBill}
                  didMound={true}
                  getBenefitsAndPayments={this.getBenefitsAndPayments}
                  benefitsFetching={benefitsFetching}
                  setPostal={this.setPostal}
                  noFnPayBgt={noFnPayBgt}
                  showFn={showFn}
                />
              ) : (
                <StateInput setPostal={this.setPostal} />
              )
            }
            class={classes.paperClass}
          />
        </Grid>
      </Grid>
    );
  }
}

EnergyCostCalculator.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
  actions: PropTypes.object,
  stateCode: PropTypes.string,
  estimatedBill: PropTypes.object,
  stateFetching: PropTypes.bool,
  benefitsFetching: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    ...state.energyCostCalcReducer.toJS(),
    ...state.benefitsReducer.toJS()
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        findState,
        getEstimatedBill,
        getBenefitsAndPayments
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EnergyCostCalculator));
